export default __webpack_public_path__ + "static/media/Hubano-2Open.88725da5.jpg";